import FormTemplate from './FormTemplate';
export default FormTemplate;